import { Component, Inject, OnInit } from '@angular/core';
import { PersonalDataService } from '../../personalData/personal-data.service';
import { Contact } from '../../../../common/models/contact';
import { OccupationEnum } from '../../../../common/helper/enums';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilitiesService } from '../../../../common/shared/services/utilities.service';

@Component({
  selector: 'app-occupation-form',
  templateUrl: './occupation-form.component.html'
})
export class OccupationFormComponent implements OnInit {
  contact: Contact;

  OccupationEnum: typeof OccupationEnum = OccupationEnum;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public input: any,
    private _dialogRef: MatDialogRef<OccupationFormComponent>,
    private _personalDataService: PersonalDataService,
    public utilitiesService: UtilitiesService
  ) { }

  ngOnInit(): void {
    this.contact = new Contact();
    if (this.input !== null) {
      // Creating new instance/do a deep copy to not sync data between View and Edit.
      this.contact = JSON.parse(JSON.stringify(this.input.contact));
    }
  }

update() {
    this.utilitiesService.addMinorAction('UpdatePersonalData');
    this._personalDataService.updateContact(this.contact).subscribe(
      data => {
        this.utilitiesService.removeAction('UpdatePersonalData');
        if (this.utilitiesService.getData(data)) {
          this._dialogRef.close('Success');
        } else {
          this._dialogRef.close('Error');
        }
      },
      err => {
        this.utilitiesService.handleErrors(err);
        this._dialogRef.close('Close');
      }
    );
  }

  updateActionActive() {
    return this.utilitiesService.isActionActive('UpdatePersonalData');
  }
}
